import { inject } from '@angular/core';
import { AppFeatureActions } from '@app/app.actions';
import { FormFieldSyncActions } from '@core/data-access/store/form/form.actions';
import { AnonymousVoucherActions } from '@core/data-access/store/shared/shared.actions';
import { selectSavedBuyerFormFields } from '@core/features/account/features/saved-ticket-holders/store/saved-ticket-holder.selectors';
import { enableDisabledFormFields, removeNonQuestionnaireFormFields } from '@core/utils/form-fields/form-field-helpers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { isEmpty } from 'lodash';
import { filter, map } from 'rxjs';
import { BuyerQuestionnaireDynamicFieldsActions } from './buyer-questionnaire.actions';

export const setBuyerQuestionnaireDynamicFields$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(AppFeatureActions.buyerQuestionnaireFeatureAdded),
      map(({ dynamicBuyerQuestionnaireFields }) =>
        BuyerQuestionnaireDynamicFieldsActions.setBuyerQuestionnaireDynamicFields(dynamicBuyerQuestionnaireFields)
      )
    ),
  { functional: true }
);

export const setBuyerQuestionnairePrefillOnAnonymousVoucherRelease$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(AnonymousVoucherActions.anonymousVoucherIsReleased),
      concatLatestFrom(() => store.select(selectSavedBuyerFormFields)),
      map(([_, savedBuyerFormFields]) => removeNonQuestionnaireFormFields(savedBuyerFormFields)),
      filter((savedBuyerQuestionnaireFormFields) => !isEmpty(savedBuyerQuestionnaireFormFields)),
      map((savedBuyerFormFields) =>
        FormFieldSyncActions.setBuyerQuestionnaireFormFields({
          formFields: enableDisabledFormFields(savedBuyerFormFields)
        })
      )
    ),
  { functional: true }
);

export const resetBuyerQuestionnaireDynamicFields$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(AppFeatureActions.buyerQuestionnaireFeatureRemoved),
      map(() => BuyerQuestionnaireDynamicFieldsActions.resetBuyerQuestionnaireDynamicFields())
    ),
  { functional: true }
);
